angular.module('app.services').service('groupsService', function (api) {
    const Service = this;

    Service._model = api('groups');

    Service.getAll = () => Service._model.list().then((response) => response.data);

    Service.selectize = () =>
        Service._model
            .selectize({
                transform: {
                    id: 'id',
                    value: ':name',
                },
            })
            .then((response) => _.sortBy(response.data, 'label'));

    Service.find = (id) => Service._model.get(id).then((response) => response.data);

    Service.save = (group) => Service._model.post(group);
});
